/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClimateTemplate } from '../../models/climate-template';

export interface ClimateTemplateSTokenGet$Params {
  sToken: string;
}

export function climateTemplateSTokenGet(http: HttpClient, rootUrl: string, params: ClimateTemplateSTokenGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ClimateTemplate>> {
  const rb = new RequestBuilder(rootUrl, climateTemplateSTokenGet.PATH, 'get');
  if (params) {
    rb.path('sToken', params.sToken, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClimateTemplate>;
    })
  );
}

climateTemplateSTokenGet.PATH = '/climateTemplate/{sToken}';
